export default `
# Image Filter
`;



// WEBPACK FOOTER //
// ./src/components/project-documentations/documentations/image-filter.ts